const languageIconStyle = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0px 10px 0px 10px',
};

const globeIconStyle = {
    marginRight: '5px',
};
const currentLanguageTextStyle = {
    fontSize: '12px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
};

const LanguageIcon = ({ currentLanguage }) => {
    return (
        <div style={languageIconStyle}>
            <i style={globeIconStyle}>
                {currentLanguage?.icon || 'icon-unfound'}
            </i>{' '}
            {/* Replace with an actual icon */}
            <span style={currentLanguageTextStyle}>
                {currentLanguage?.shortcut || 'shortcut-unfound'}
            </span>
        </div>
    );
};

export default LanguageIcon;
